import { characterIllustrationAssetFiles } from './assets';
import type { CharacterIllustrationAssetFile } from './assets';
import type { CharacterIllustrationName } from './names';
import type { CharacterIllustrationVariant } from './types';

/**
 * Resolve a name + variant to its asset filename (relative to
 * packages/design-system/assets/illustrations/).
 */
export function getCharacterIllustrationAssetFile(
  name: CharacterIllustrationName,
  variant: CharacterIllustrationVariant,
): CharacterIllustrationAssetFile {
  return characterIllustrationAssetFiles[name][variant];
}
